const initState = {
    students: [
        {name:'abcdef', isGivingExam:true, isDisqualified:false},
    ]
}

const studentReducer = (state = initState, action) => {
    return state
}

export default studentReducer;